let React =            require("react");

let DataListPage =     require("../../pages/generic/DataListPage.jsx");
let EmptyPackageCard = require("../empty/EmptyPackageCard.jsx");
let NewPackageButton = require("../buttons/NewPackageButton.jsx");
let PackageCard =      require("../cards/PackageCard.jsx");

class PackagesHub extends React.Component {

    shouldComponentUpdate(nextProps){
        return  Number(this.props.hub.id) !== Number(nextProps.hub.id) ||
                Boolean(this.props.hub.deleted) !== Boolean(nextProps.hub.deleted)
    }

    render() {
        const hubDeleted = Boolean(this.props.hub.deleted);

        const WrappedPackageCard = props => <PackageCard {...props} hubDeleted={hubDeleted}/>;
        const WrappedNewPackageButton = props => <NewPackageButton {...props} idHub={this.props.hub.id} hubDeleted={hubDeleted}/>;
        const WrappedEmptyPackageCard = props => <EmptyPackageCard {...props} idHub={this.props.hub.id}/>;

        return  <DataListPage
                    {...this.props}
                    endpoint="/packages/search?"
                    filtersEndpoint={{hub: this.props.hub.id}}
                    displayName={`Packages from "${this.props.hub.name}"`}
                    urlName="packages"
                    cssCardTag="package"
                    loginRequired
                    canSwitchLayout
                    showCover={false}
                    switchThumbnail={true}
                    showUploadNewAsset={!hubDeleted}
                    UploadNewAsset={WrappedNewPackageButton}
                    EmptyCard={WrappedEmptyPackageCard}
                    CardType={WrappedPackageCard}
                />
    }
}

module.exports = PackagesHub;
